import clsx from 'clsx';
import React from 'react';
import {
  Control,
  FieldError,
  FieldErrorsImpl,
  FieldValues,
  Merge,
  RegisterOptions,
  UseFormRegister,
} from 'react-hook-form';

import { Size } from '@/hooks/useScreenSize';

import InputField from './InputField';

interface PhoneNumberFieldProps {
  className?: string;
  control: Control<FieldValues>;
  containerClassName?: string;
  disabled?: boolean;
  error?: FieldError | Merge<FieldError, FieldErrorsImpl<FieldValues>>;
  errorClassName?: string;
  errorMsg: string;
  icon: JSX.Element;
  iconClassName?: string;
  maxLength?: number;
  minLength?: number;
  name: string;
  onBlur?: (_event: React.FocusEvent<HTMLInputElement>) => void;
  onChange?: (
    _event: React.ChangeEvent<HTMLInputElement>,
    _inputRef?: React.RefObject<HTMLInputElement>
  ) => void;
  placeholder: string;
  readOnly?: boolean;
  register: UseFormRegister<FieldValues>;
  rules?: RegisterOptions;
  type?: string;
  size: Size;
  wrapperClassName?: string;
}

export const PhoneNumberField = ({
  className,
  control,
  containerClassName,
  disabled,
  error,
  errorClassName,
  errorMsg,
  icon,
  iconClassName,
  maxLength,
  minLength,
  name,
  onBlur,
  onChange,
  placeholder,
  readOnly,
  register,
  rules,
  type = 'tel',
  size: _size,
  wrapperClassName = 'flex flex-col gap-2',
}: PhoneNumberFieldProps) => {
  return (
    <div className={wrapperClassName}>
      <InputField
        className={className}
        control={control}
        containerClassName={containerClassName}
        disabled={disabled}
        errorMsg={errorMsg}
        errors={error}
        icon={icon}
        iconClassName={iconClassName}
        maxLength={maxLength}
        minLength={minLength}
        name={name}
        onBlur={onBlur}
        onChange={onChange}
        placeholder={placeholder}
        readOnly={readOnly}
        register={register}
        rules={rules}
        type={type}
      />
      {error ? (
        <p className={clsx(errorClassName)}>
          {typeof error.message === 'string' ? error.message : ''}
        </p>
      ) : null}
    </div>
  );
};
